import React from "react";
import { Grid2 } from "@mui/material";
import { useDispatch } from "react-redux";

import { TitleMenuComponent, AppInput, PassChangeButton } from "..";
import { appRouteEnums, menuTitleEnums } from "@enums";
import { SearchIcon } from "@assets";
import { selectPreloadData, selectPreloadDataLoading, setInstrumentsCategory, useAppSelector } from "@redux";
import {
  StyledInstrumentsView,
  InstrumentsListItemComponent,
  InstrumentCatetoryComponent,
} from ".";
//import { categoriesApi, instrumentApi } from "@api";
//import { updateSnackBar } from "@redux";
import { API_CATEGORY_TYPE_INSTRUMENT, PLACEHOLDER_SEARCH } from "@configs";
import { useWindowDimensions, useAppNavigation } from "@utils";
import { useHistory, useLocation } from "react-router-dom";
import mobile_arrow_left from "@assets/Icons/arrow/mobile_arrow_left.svg";
//import { sub } from "date-fns";
//import { update } from "lodash";

export const InstrumentsView = () => {
  // hooks
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();

  //URLでフィルター完結させるために追加
  const categoryId = query.get("categoryId");
  const subCategoryId = query.get("subCategoryId");
  const keywordFromUrl = query.get("keyword") || "";
  const [inputValue, setInputValue] = React.useState<string>(keywordFromUrl || "");

  //const subCategoryId = query.get("subCategoryId");
  const dispatch = useDispatch();
  const width = useWindowDimensions().width;
  const history = useHistory();
  const { navigateWithState } = useAppNavigation();
  //component state
  //const [categories, setCategories] = React.useState<Array<any>>();
  const [category, setCategory] = React.useState<string>("");
  const [selectedIndex, setSelectedIndex] = React.useState(-1);
  const messagesEndRef = React.useRef<any>(null);
  //const [loading, setLoading] = React.useState<boolean>(false);
  //const [listProducts, setListProducts] = React.useState<any>();
  const [categoryViewMobile, setCategoryViewMobile] = React.useState<boolean>(true);

  const preloadData = useAppSelector(selectPreloadData);
  const preloadDataLoading = useAppSelector(selectPreloadDataLoading);

  //キーワード検索
  React.useEffect(() => {
    setInputValue(keywordFromUrl);
  }, [keywordFromUrl]);

  //カレンダーページで利用するため値更新
  React.useEffect(() => {
    dispatch(setInstrumentsCategory({
      categoryId: categoryId,
      subCategoryId: subCategoryId,
    }));
  }, [categoryId, subCategoryId, keywordFromUrl]);

  const instruments = !preloadData?.instrumentItems ? [] : preloadData.instrumentItems
    .filter(instrument => instrument.status)
    .map(instrument => {
      const instrumentCopy = { ...instrument };
      const instrumentObject = preloadData.instruments.find(item => item.id === instrumentCopy.instrument_id);
      const instrumentAttachment = preloadData.attachments.find(attachment =>
        attachment.attachmentable_id === instrumentCopy.id &&
        attachment.attachmentable_type.toLowerCase().endsWith("instrumentitem")
      );

      const instrumentImage = {
        id: instrumentAttachment?.id,
        path: instrumentAttachment?.path,
        updated_at: instrumentAttachment?.updated_at,
      };

      const instrumentBorrowings = preloadData.borrowings.filter(borrowing =>
        borrowing.borrowingable_id === instrumentCopy.id &&
        borrowing.borrowingable_type.toLowerCase().endsWith("instrumentitem")
      );
      const instrumentReturns = preloadData.returnedItems.filter(returnedItem =>
        returnedItem.borrowingable_id === instrumentCopy.id &&
        returnedItem.borrowingable_type.toLowerCase().endsWith("instrumentitem")
      );

      let borrowing = false;
      let isLate = false;

      instrumentBorrowings.forEach(borrowingItem => {
        const connectedReturn = instrumentReturns.find(returnItem => returnItem.borrowing_id === borrowingItem.id);
        if (!connectedReturn) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const startDate = new Date(borrowingItem.from);
          const endDate = new Date(borrowingItem.to);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);

          if (startDate <= today && today <= endDate) {
            borrowing = true;
          }

          if (endDate < today) {
            borrowing = true;
            isLate = true;
          }
        }
      });

      return {
        ...instrumentCopy,
        name: instrumentObject?.name,
        image: instrumentImage,
        borrowing: !borrowing, // This is BACKWARDS, the child component uses borrowing=true to mean it's NOT being borrowed
        isLate: isLate,
      };
    }).sort((a, b) => a.position - b.position);

  //console.log(instruments);

  const instrumentCategories = !preloadData?.categories ? [] : preloadData.categories
    .filter(category => category.type === API_CATEGORY_TYPE_INSTRUMENT && category.parent_id === 0) // Get top-level instrumen categories
    .sort((a, b) => a.position - b.position)
    .map(parentCategory => ({
      ...parentCategory, // Copy all properties of the parent category
      title: parentCategory.name, // Rename 'name' to 'title'
      subCategory: preloadData.categories
        .filter(subCategory => subCategory.type === API_CATEGORY_TYPE_INSTRUMENT && subCategory.parent_id === parentCategory.id) // Get matching instrumen sub-categories
        .sort((a, b) => a.position - b.position)
    }));

  //console.log(instrumentCategories);

  // call api get categories
  //    React.useEffect(() => {
  //        const fetchCategoriesApi = async () => {
  //            try {
  //                const response = await categoriesApi.getCategories({
  //                    type: API_CATEGORY_TYPE_INSTRUMENT,
  //                });
  //                setCategories(response.data.data);
  //            } catch (err: any) {
  //                dispatch(
  //                    updateSnackBar({
  //                        messageType: "error",
  //                        message: err.response?.data?.message,
  //                    })
  //                );
  //            }
  //        };
  //        fetchCategoriesApi();
  //    }, []);
  // events
  const handleOnChange = (value: string) => {
    setInputValue(value || "");
  };
  //What: scroll to bottom to view data results when device is mobile
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  //what: call api get list products
  //    const fetchListProducts = async (params: any) => {
  //        setLoading(true);
  //        try {
  //            const response = await instrumentApi.getViewListProducts({
  //                category: subCategoryId?.toString() || "",
  //                name: params.name || "",
  //            });
  //            setLoading(false);
  //            setListProducts(response.data.data);
  //        } catch (err: any) {
  //            setListProducts(undefined);
  //            setLoading(false);
  //        }
  //    };
  //    React.useEffect(() => {
  //        const fetchCategoriesApi = async () => {
  //            try {
  //                const response = await categoriesApi.getCategories({
  //                    type: API_CATEGORY_TYPE_INSTRUMENT,
  //                });
  //                setCategories(response.data.data);
  //            } catch (err: any) {
  //                dispatch(
  //                    updateSnackBar({
  //                        messageType: "error",
  //                        message: err.response.data.message,
  //                    })
  //                );
  //            }
  //        };
  //        fetchCategoriesApi();
  //    }, []);

  //Reduxで取得した値はフィルターに使用しないためコメントアウト（混在防ぐため）
  //what: call api in search form
  // const handleOnSearchSubmit = () => {
  //   setCategoryViewMobile(false);
  //   //        fetchListProducts({
  //   //            name: inputValue,
  //   //            category: "",
  //   //        });
  //   setSelectedIndex(-1);
  //   if (width < 768) {
  //     scrollToBottom();
  //   }
  //   dispatch(
  //     setInstrumentsCategory({
  //       category: "",
  //       subCategory: "",
  //     })
  //   );
  // };

  //URLでフィルター完結させるために追加
  const handleOnSearchSubmit = () => {
    const params = new URLSearchParams(location.search);
    if (categoryId) params.set("categoryId", categoryId);
    setCategoryViewMobile(false);
    setSelectedIndex(-1);
    if (width < 768) {
      scrollToBottom();
    }
    params.set("keyword", inputValue);
    history.push(`/instruments?${params.toString()}`);
  };

  // URLでフィルター管理（autoモード: 初回はpush、それ以降はreplace）
  // fromは引き継がない
  const handleSelectCategory = (subCategory, parentCategoryId) => {
    setCategoryViewMobile(false);
    setCategory(parentCategoryId);
    const query = keywordFromUrl ? { keyword: keywordFromUrl } : {};
    navigateWithState(
      "/instruments",
      { categoryId: parentCategoryId, subCategoryId: subCategory.id, ...query },
      "auto"
    );
  };

  //Reduxで取得した値はフィルターに使用しないためコメントアウト（混在防ぐため）
  //what: select a subCategory ID
  // const handleSelectCategory = (values: any, categoryId: number) => {
  //   dispatch(
  //     setInstrumentsCategory({
  //       category: values.title,
  //       categoryId: categoryId,
  //       subCategory: values.subTitle,
  //       subCategoryId: values.id,
  //     })
  //   );
  //   setInputValue("");
  //   setCategoryViewMobile(false);
  //   setCategory(values.id);
  //   history.push(`/instruments?categoryId=${categoryId}&subCategoryId=${values.id}`);
  // };
  //what: call api after re-render
  //how: when category id is updated, this page is re-render
  //    React.useEffect(() => {
  //        fetchListProducts({
  //            category: category,
  //        });
  //    }, [category]);

  //大カテゴリクリックはトグルのみに限定するためコメントアウト
  //WHAT: active select category
  // const handleClick = (index: number, category: any) => {
  //   const isActive =
  //     selectedIndex === index || String(categoryId) === String(category.id);
  //   if (isActive) {
  //     // if active, toggle it off
  //     setSelectedIndex(-1);
  //     history.push("/instruments"); // clear URL query params
  //   } else {
  //     // if not active, toggle this category on and clear any URL driven active state
  //     setSelectedIndex(index);
  //     history.push("/instruments");
  //   }
  // };

  //大カテゴリクリックはトグルのみに限定
  const handleClick = (index: number) => {
    setSelectedIndex(selectedIndex === index ? -1 : index);
  };

  // URLクエリ -> UI同期（カテゴリ展開状態）
  React.useEffect(() => {
    // クエリがなければ展開をすべて閉じる
    if (!categoryId && !subCategoryId) {
      setSelectedIndex(-1);
      return;
    }
    // categoryId がある場合は対応する親カテゴリを展開
    if (categoryId && instrumentCategories?.length) {
      const parentIndex = instrumentCategories.findIndex((c: any) => String(c.id) === String(categoryId));
      if (parentIndex >= 0) setSelectedIndex(parentIndex);
    }
  // instrumentCategories は毎レンダーで新規配列になるため length の変化に限定
  }, [categoryId, subCategoryId, instrumentCategories.length]);

  //URLでフィルター完結させるために追加
  const filteredInstruments = instruments
    .filter(instrument => !subCategoryId || Number(instrument.category_id) === Number(subCategoryId))
    .filter(instrument => !keywordFromUrl || instrument.name.toLowerCase().includes(keywordFromUrl.toLowerCase()));

  //Reduxで取得した値はフィルターに使用しないためコメントアウト（混在防ぐため）
  // const filteredInstruments = category ?
  //   instruments.filter(instrument => instrument.category_id === category) :
  //   inputValue ? instruments.filter(instrument => instrument.name.toLowerCase().includes(inputValue.toLowerCase())) :
  //     instruments;

  const inputValueMatchCount = inputValue ? filteredInstruments.length : undefined;

  //フィルターリセット
  const handleClearFilters = () => {
    // Reset UI states as well as query parameters
    setInputValue("");
    setSelectedIndex(-1);
    setCategory("");
    setCategoryViewMobile(true);

    const params = new URLSearchParams(location.search);
    params.delete("categoryId");
    params.delete("subCategoryId");
    params.delete("keyword");

    const remainingQueryString = params.toString();
    history.push(remainingQueryString ? `/instruments?${remainingQueryString}` : "/instruments");
  };

  return (
    <StyledInstrumentsView>
      {/* <AppTopBar /> */}
      <div className="instruments">
        <div className="instruments__top">
          {/* <p
            className="newOT__top-icon"
            onClick={() => history.push(appRouteEnums.PATH_HOME)}
          >
            <AppIconButton icon={<img src={mobile_arrow_left} alt="icon" />} />
          </p> */}
          <Grid2 container spacing={4} alignItems={"center"}>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <div className="instruments__top-title">
                <TitleMenuComponent text={menuTitleEnums.TITLE_INSTRUMENTS} />
              </div>
              {(categoryId || keywordFromUrl) && (
                <PassChangeButton onClick={handleClearFilters}>
                  フィルターリセット
                </PassChangeButton>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
              <PassChangeButton onClick={() => history.push({
                pathname: appRouteEnums.PATH_INSTRUMENTS_BORROWING_CALENDAR,
                state: { searchWord: inputValue }
              })}>カレンダー表示</PassChangeButton>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
              <div className="instruments__top-searchForm" style={{ flexDirection: "column" }}>
                <AppInput
                  value={inputValue}
                  iconStart={<SearchIcon />}
                  handleChange={handleOnChange}
                  placeholder={PLACEHOLDER_SEARCH}
                  disabled={false}
                  name="searchValue"
                  onClick={handleOnSearchSubmit}
                />
                {inputValueMatchCount !== undefined ? <span style={{ fontSize: "0.8em", color: "#666", padding: "0.5rem 2rem" }}>一致数: {inputValueMatchCount}</span> : null}
              </div>
            </Grid2>
          </Grid2>
        </div>
        <div className="instruments__content visible-pc ">
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
              <div className="category">
                {instrumentCategories &&
                  instrumentCategories?.map((category, index) => (
                    <div key={category.id}>
                      <InstrumentCatetoryComponent
                        category={category}
                        checked={
                          String(categoryId) === String(category.id) ||
                          index === selectedIndex
                        }
                        onClick={() => handleClick(index)}
                        handleSelectSubCategory={handleSelectCategory}
                      />
                    </div>
                  ))}
              </div>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 9, lg: 9 }}>
              <div className="listItem" ref={messagesEndRef}>
                <InstrumentsListItemComponent
                  loading={preloadDataLoading}
                  products={filteredInstruments}
                  categoryId={category}
                />
              </div>
            </Grid2>
          </Grid2>
        </div>
        <div className="instruments__content visible-mobile">
          {categoryViewMobile ? (
            <div className="category">
              {instrumentCategories &&
                instrumentCategories?.map((category, index) => (
                  <div key={category.id}>
                    <InstrumentCatetoryComponent
                      category={category}
                      checked={
                        String(categoryId) === String(category.id) ||
                        index === selectedIndex
                      }
                      onClick={() => handleClick(index)}
                      handleSelectSubCategory={handleSelectCategory}
                    />
                  </div>
                ))}
            </div>
          ) : (
            <div>
              <div
                style={{ width: "100%", textAlign: "left", padding: "2rem 0" }}
                onClick={() => setCategoryViewMobile(true)}
              >
                <img src={mobile_arrow_left} alt="icon" />
              </div>
              <InstrumentsListItemComponent
                loading={preloadDataLoading}
                products={filteredInstruments}
                categoryId={category}
              />
            </div>
          )}
        </div>
      </div>
    </StyledInstrumentsView>
  );
};
